import { AxiosInstance } from "axios";
import { LoginResponse } from "../types/LoginResponse";
import { Tenants } from "../types/Tenants";

export default class AccountService {
  private _endpoint = "/account";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async Login(
    username: string,
    password: string,
  ): Promise<LoginResponse> {
    const tenantConfig = process.env.REACT_APP_TENANT || "default";
    let tenant = Tenants.DataCutter;
    if (tenantConfig.toLowerCase() === "inrix") {
      tenant = Tenants.Inrix;
    }

    return this._client
      .post<LoginResponse>(this._endpoint + "/login", {
        UsernameOrEmail: username,
        password,
        clientIp: "",
        userAgent: "",
        languageId: 0,
        additionalClaims: {
          Tenant: tenant
        }
      })
      .then((response) => {
        return response.data;
      });
  }

  public async LoginSso(
    token: string,
    refreshToken: string,
  ): Promise<LoginResponse> {
    return this._client
      .post<LoginResponse>(this._endpoint + "/loginSso", {
        token,
        refreshToken,
      })
      .then((response) => {
        return response.data;
      });
  }

  public async ForgottenPassword(email: string): Promise<boolean> {
    return this._client
      .post<boolean>(`${this._endpoint}/forgottenPassword`, {
        email,
      })
      .then((response) => {
        return response.data;
      });
  }

  public async RefreshToken(
    token: string,
    refreshToken: string,
    clientId: string,
  ): Promise<any> {
    return this._client
      .post<any>(this._endpoint + "/refreshToken", {
        token,
        refreshToken,
        clientId,
      })
      .then((response) => {
        return response.data;
      });
  }

  public async Logout(): Promise<any> {
    return this._client.post(this._endpoint + "/logout");
  }
}
